module.exports = __webpack_public_path__ + "img/recently_deleted.a301b6b7.svg";